// useBodyClass.js
import { useEffect } from 'react';

function useBodyClass(cls) {
  useEffect(() => {
    if (typeof document === 'undefined') return; // SSR-safe
    document.body.classList.add(cls);

    return () => {
      document.body.classList.remove(cls);
    };
  }, [cls]);
}

export default useBodyClass;
